"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readFromStorage = exports.saveToStorage = void 0;
const uuid_1 = require("uuid");
const constants_1 = require("./constants");
function saveToStorage(params, storage, logger, storageKey = constants_1.STORAGE_KEY) {
    const { sessionId, guestId, events, lastEventTime } = params;
    const data = {
        sessionId,
        guestId,
        events,
        lastEventTime,
    };
    logger.debug('Updating local storage with:', data);
    storage.setItem(storageKey, JSON.stringify(data));
}
exports.saveToStorage = saveToStorage;
const readFromStorage = ({ callback, storage, logger, storageKey = constants_1.STORAGE_KEY, }) => {
    logger.debug('Reading from local storage');
    const item = storage.getItem(storageKey);
    if (typeof item === 'string') {
        const data = JSON.parse(item);
        logger.debug('Local storage data', data);
        callback(data);
    }
    else if (item instanceof Promise) {
        item.then(value => {
            if (value) {
                const data = JSON.parse(value);
                logger.debug('Local storage data', data);
                callback(data);
            }
            else {
                callback({
                    sessionId: (0, uuid_1.v4)(),
                    guestId: (0, uuid_1.v4)(),
                    events: [],
                    lastEventTime: Date.now(),
                });
            }
        });
    }
    else {
        callback({
            sessionId: (0, uuid_1.v4)(),
            guestId: (0, uuid_1.v4)(),
            events: [],
            lastEventTime: Date.now(),
        });
    }
};
exports.readFromStorage = readFromStorage;
//# sourceMappingURL=storage.js.map